
export default {
  name: 'AgeCalculator',
  jsonld() {
    return {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [{
        "@type": "Question",
        "name": "Does the calculator account for leap years?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The short answer is yes. The leap year calculator will help you discover how leap years are calculated and all the exciting details related to this day, month, and year. Like a regular birth age calculator online, this tool estimates the exact time between two different times in desired units."
        }
      },{
        "@type": "Question",
        "name": "Does the date calculator take into account the end date?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The truth is yes. The date of birth calculator also includes the end date in the results provided to the user. It is helpful for those who want to know how many days a particular event has lasted. For example, if you have to work from day 1 to day 4 in a week, your final day result will be 4. Many believe the last day (the end date) is not counted as an additional date. Therefore, you should uncheck this item when calculating the exact age of an event or phenomenon."
        }
      },{
        "@type": "Question",
        "name": "Can Google Forms calculate age?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, using the DIFF and TODAY functions, you can easily calculate age on Google Forms."
        }
      },{
        "@type": "Question",
        "name": "What is the easiest way to figure out someone's age?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "The exact age calculator is the fastest way to calculate an age when the person's date of birth is known. If you want to figure it out manually, subtract the birth date from the current date, and you will get the result. For example, this year is 2022, and you were born in 2003. So your age is 2022 - 2003 = 19. You can also find age by asking relatives, friends, or colleagues or checking their resumes."
        }
      },{
        "@type": "Question",
        "name": "Can Excel figure out age from DOB?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "From many different perspectives, calculating age is subtracting between two-time points. This current-age calculation formula also exists in Excel software through calculation functions. Specifically, the first time the formula (TODAY()-B2) will tell you the exact difference between the current date and the date of birth. Next, you need to divide the result you just found by 365 to get the final answer."
        }
      }]
    };
  },
  head() {
    return {
      link: [
        { rel: 'stylesheet', href: '/assets/css/vendors.min.css' }
      ]
    }
  },
  mounted: function () {
    new Litepicker({
    element: document.getElementById('datepicker-startDate'),
    startDate: new Date(),
    buttonText: {
      previousMonth: `<svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><polyline points="15 6 9 12 15 18" /></svg>`,
      nextMonth: `<svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><polyline points="9 6 15 12 9 18" /></svg>`,
    }
    });

    new Litepicker({
    element: document.getElementById('datepicker-endDate'),
    startDate: new Date(),
    buttonText: {
      previousMonth: `<svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><polyline points="15 6 9 12 15 18" /></svg>`,
      nextMonth: `<svg xmlns="http://www.w3.org/2000/svg" class="icon" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round"><path stroke="none" d="M0 0h24v24H0z" fill="none"/><polyline points="9 6 15 12 9 18" /></svg>`,
    }
    });
  },
  data () {
    return {
      data: '',
      form: this.$vform({
        startDate: '',
        endDate: ''
      })
    }
  },
  methods: {
    onAgeCalculator() {
        this.form.startDate = jQuery('#datepicker-startDate').val();
        this.form.endDate   = jQuery('#datepicker-endDate').val();
        this.form.post(`/tool/age-calculator`, { progress: false }).then(res => {
          this.data = res.data;
        }).catch(e => {
          console.log(e);
        });
    }
  }
}
